"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3133],{

/***/ 43133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Modes_Modes; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Picture/index.ts + 1 modules
var Picture = __webpack_require__(17856);
;// CONCATENATED MODULE: ./src/blocks/Modes/Modes.tsx



const Modes = (param)=>{
    let { blockData  } = param;
    const { data: { element , background =""  }  } = blockData;
    const items = Object.values(element);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "modes ".concat(background === "grey" ? "mainBackgroundGrey" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modes__container desktop-container",
            children: items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "modes__bigCard",
                    children: [
                        item.mediaId && item.mediaId.publicUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                            data: item.mediaId,
                            className: "modes__bigCard__img"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "modes__bigCard__header",
                            children: item.header
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modes__bigCard__content",
                            dangerouslySetInnerHTML: {
                                __html: item.lead
                            }
                        })
                    ]
                }, index))
        })
    });
};
/* harmony default export */ var Modes_Modes = (Modes);

;// CONCATENATED MODULE: ./src/blocks/Modes/index.ts



/***/ })

}]);